import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { FarmerCreateOptionsType, FarmersService } from '~/api/services/farmers'
import Layout from '~/components/Layout'
import { formatNumber, formatNumberWithoutFractions, handleErrors } from '~/utils/helpers'
import { StyledGridColumns, StyledGridRow } from '~/pages/Dairy/MilkFixedPrice/ShowMilkFixedPrice/style'
import { Button, Divider, Grid } from 'semantic-ui-react'
import { useAuth } from '~/routes/components/AuthProvider'
import localeData from 'dayjs/plugin/localeData'
import { StyledSegment } from './style'
import EditAmountDrawer from './EditAmountDrawer'
import dayjs from 'dayjs'

interface Props {
  farmerOptions: FarmerCreateOptionsType
}

const HedgingInfo:React.FC<Props> = ({ farmerOptions }) => {
  const { t } = useTranslation()
  const { id } = useParams()
  const { systemData: { amountUnit } } = useAuth()
  dayjs.extend(localeData)

  const [hedgingData, setHedginData] = useState(null)
  const [isBusy, setIsBusy] = useState(false)
  const [editAmountData, setEditAmountData] = useState(null)

  useEffect(() => {
    fetchData()
  }, [])

  async function fetchData() {
    setIsBusy(true)
    try {
      const response = await FarmersService.getHedgingInfo(id)
      setHedginData(response.data)
    } catch(error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  function renderHedgingInfo() {
    return <StyledSegment placeholder loading={isBusy}>
      <Grid columns={2} stackable>
        <Divider vertical />
        <Grid.Column>
          <Grid columns={2} stackable>
            <StyledGridRow>
              <Grid.Column>{t('Yearly amount (in {{amountUnit}})', { amountUnit })}</Grid.Column>
              <StyledGridColumns>{hedgingData?.amount ?
                `${formatNumberWithoutFractions(hedgingData?.amount)} ${amountUnit}` : t('Not defined')}</StyledGridColumns>
            </StyledGridRow>
            <StyledGridRow>
              <Grid.Column>{t('Yearly trading amount (in %)')}</Grid.Column>
              <StyledGridColumns>{hedgingData?.amountPercent ? formatNumber(hedgingData?.amountPercent) : t('Not defined')}</StyledGridColumns>
            </StyledGridRow>
            <StyledGridRow>
              <Grid.Column>{t('Max yearly trading amount (in {{amountUnit}})', { amountUnit })}</Grid.Column>
              <StyledGridColumns>{hedgingData?.tradingAmount ?
                `${formatNumberWithoutFractions(hedgingData?.tradingAmount)} ${amountUnit}` : t('Not defined')}</StyledGridColumns>
            </StyledGridRow>
          </Grid>
        </Grid.Column>
     
        {/*     {tradingVolumeTypes?.length > 0 ? tradingVolumeTypes?.map(trading => {
              const name = trading?.name
              return <StyledGridRow key={trading.id}>
                <Grid.Column>{t('{{name}} (in {{amountUnit}})', { amountUnit, name })}</Grid.Column>
                <StyledGridColumns>{`${formatNumberWithoutFractions(trading?.tradingAmount) || 0} ${amountUnit}
                [${trading?.percent ? formatNumber(trading?.percent) : '0,00'} %]`}</StyledGridColumns>
              </StyledGridRow>
            }) : '-'} */}
        <Grid.Column>
          <Grid columns={2} stackable>
            <StyledGridRow>
              <Grid.Column>{t('Max monthly trading amount (in {{amountUnit}})', { amountUnit })}</Grid.Column>
              <StyledGridColumns>{hedgingData?.monthlyTradingAmount ?
                `${formatNumberWithoutFractions(hedgingData?.monthlyTradingAmount)} ${amountUnit}` : t('Not defined')}</StyledGridColumns>
            </StyledGridRow>
            <StyledGridRow>
              <Grid.Column>{t('Minimum contingent (in {{amountUnit}})', { amountUnit })}</Grid.Column>
              <StyledGridColumns>{hedgingData?.minimumContingent ?
                `${formatNumberWithoutFractions(hedgingData?.minimumContingent)} ${amountUnit}` : t('Not defined')}</StyledGridColumns>
            </StyledGridRow>
          </Grid>
        </Grid.Column>
      </Grid>

    </StyledSegment>
  }

  function addMonthsAndAmounts(data) {
    const lastMonthIndex = dayjs().month() - 1
    const monthsAndAmounts = []
    for (let i = lastMonthIndex, j = 0; i >= 0; i--, j++) {
      const date = dayjs(new Date(`${dayjs().year()}-${i + 1 >= 10 ? i + 1 : `0${i + 1}`}-01`)).format('YYYY-MM-DD')
      const findIndexAmount = id ? data.findIndex(amount => amount.month === date) : -1
      monthsAndAmounts.push({
        month: date,
        amount: findIndexAmount >= 0 ? data[findIndexAmount].amount : ''
      })
    }
    for (let i = 11, j = lastMonthIndex + 1; i > lastMonthIndex; i--, j++) {
      const date = dayjs(new Date(`${dayjs().year() - 1}-${i + 1 >= 10 ? i + 1 : `0${i + 1}`}-01`)).format('YYYY-MM-DD')
      const findIndexAmount = id ? data.findIndex(amount => amount.month === date) : -1
      monthsAndAmounts.push({
        month: date,
        amount: findIndexAmount >= 0 ? data[findIndexAmount].amount : ''
      })
    }
    return monthsAndAmounts
  }

  function renderActions() {
    return <Button
      content={t('Edit amount')}
      icon='pencil'
      labelPosition='left'
      style={{ color: 'white' }}
      onClick={() => {
        setEditAmountData({
          amountType: hedgingData?.amountType,
          amount: hedgingData?.amount,
          amounts: addMonthsAndAmounts(hedgingData?.amounts || [])
        })
      }}
    />
  }

  function renderEditAmountDrawer() {
    return <EditAmountDrawer
      editAmountData={editAmountData}
      farmerOptions={farmerOptions}
      handleHiddenDrawer={(submited) => {
        if(submited) {
          fetchData()
        }
        setEditAmountData(null)
      }}
    />
  }

  return <Layout
    title={t('Hedging info.')}
    childContainerSize={'auto'}
    useSpinner
    isBusy={isBusy}
    actions={renderActions()}
  >
    {renderEditAmountDrawer()}
    {renderHedgingInfo()}
  </Layout>
}
export default HedgingInfo